import React, { useState, useEffect, useRef } from 'react';
import './WhatsAppMockup.css';

const WhatsAppMockup = () => {
  const [visibleMessages, setVisibleMessages] = useState(0);
  const [isResetting, setIsResetting] = useState(false);
  const chatRef = useRef(null);

  const messages = [
    { 
      type: 'received', 
      text: 'Hola, ¿tienen mesa disponible para hoy?',
      time: '7:42'
    },
    { 
      type: 'sent', 
      text: '¡Hola! Claro que sí 😊\n¿Para cuántas personas y a qué hora?',
      time: '7:42'
    },
    { 
      type: 'received', 
      text: 'Para 4 personas a las 8pm',
      time: '7:43'
    },
    { 
      type: 'sent', 
      text: 'Perfecto 🍽️ Tenemos disponibilidad:\n🕗 Hoy – 8:00 pm (terraza)\n🕗 Hoy – 8:30 pm (interior)\n¿Cuál prefieres?',
      time: '7:43'
    },
    { 
      type: 'received', 
      text: 'La terraza, por favor',
      time: '7:44'
    },
    { 
      type: 'sent', 
      text: '✅ ¡Reservación confirmada!\nHoy 8:00 pm • Terraza • 4 personas\nTe esperamos 🙌',
      time: '7:44',
      isLast: true
    }
  ];

  useEffect(() => {
    if (isResetting) return;

    if (visibleMessages >= messages.length) {
      const resetTimer = setTimeout(() => {
        setIsResetting(true);
        setTimeout(() => {
          setVisibleMessages(0);
          setIsResetting(false);
        }, 600);
      }, 3000);
      return () => clearTimeout(resetTimer);
    }

    const timer = setTimeout(() => {
      setVisibleMessages(prev => prev + 1);
    }, 900);
    return () => clearTimeout(timer);
  }, [visibleMessages, isResetting, messages.length]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [visibleMessages]);

  return (
    <div className={`whatsapp-phone ${isResetting ? 'resetting' : ''}`}>
      <div className="phone-frame">
        <div className="phone-notch"></div>
        
        <div className="whatsapp-header">
          <div className="header-back">←</div>
          <div className="header-contact">
            <div className="contact-avatar">
              <span className="avatar-icon">🤖</span>
            </div>
            <div className="contact-info">
              <div className="contact-name">Asistente Virtual IA</div>
              <div className="contact-status">en línea</div>
            </div>
          </div>
          <div className="header-actions">
            <span className="header-icon">⋮</span>
          </div>
        </div>

        <div className="chat-background" ref={chatRef}>
          <div className={`messages-container ${isResetting ? 'fade-out' : ''}`}>
            {messages.slice(0, visibleMessages).map((message, index) => (
              <div 
                key={index} 
                className={`message-wrapper ${message.type}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={`message-bubble ${message.type}`}>
                  <div className="message-text">
                    {message.text.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        {i < message.text.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="message-time">
                    {message.time}
                    {message.type === 'sent' && (
                      <span className="checkmarks">✓✓</span>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {/* Typing indicator */}
            {visibleMessages > 0 && 
             visibleMessages < messages.length && 
             messages[visibleMessages - 1].type === 'received' && 
             !isResetting && (
              <div className="message-wrapper sent">
                <div className="message-bubble sent">
                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="whatsapp-input">
          <span className="input-icon">😊</span>
          <div className="input-field">Escribe un mensaje</div>
          <span className="input-icon">📎</span>
          <div className="voice-icon">🎤</div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppMockup;
